export class TableReportOrderCustom {
    datePreparation: Date;
	dateShipment: Date;
    dateOrder : Date;
	orderNumber : string;
	status : string;
	noc : string;
	amount : string;
	prices : number;
}